import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';

import Footer from "./Footer/Footer_00";

import Navbar from "./Navbar/Navbar_00";

import "./PaginaCustomer.css";

import * as Hosts from '../../Hosts';

import {
  reqGET,
  reqPOST,
  translate,
  repo_img_link,
  content_language,
  set_language,
  passwordHash,
  profile_access,
  functionSendMail,

} from '../../Utils';

import { usarToken } from "../../UseToken";

import { language } from './WEBContent/Language';

import "swiper/swiper-bundle.min.css";

import Loader from '../../loader';

import Swal from 'sweetalert2';

import AssecImage from "./ASSEC_Image/Image"

import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';
import parse from 'html-react-parser';

const Pagina = props => {

  const [, set_dados] = useState(null);
  const is_logged_in = useRef(null);

  const array_news = useRef(null);
  const array_notification = useRef(null);
  const array_documents = useRef(null);
  const array_downloads = useRef(null);
  const array_assistances = useRef(null);
  const array_complaints = useRef(null);
  const array_proposals = useRef(null);
  const array_suggestions = useRef(null);
  
  const [dados_config, set_dados_config] = useState({});
  const [dados_navbar, set_dados_navbar] = useState({});

  const [isloading, setLoading] = useState(true);

  const [lang, set_lang] = useState('pt');
  const [lang_id, set_lang_id] = useState('1');

  const [username, set_username] = useState('');
  const [pwd, set_pwd] = useState('');

  const [user_access_level, set_user_access_level] = useState(0)

  useEffect(() => {

    set_dados(is_logged_in.current = false)

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
      set_lang('pt')
      set_language('pt')
    }
    else {
      set_lang(localStorage.getItem('lang'))
    }

    (async () => {
        let temp_token_info = await usarToken().getToken()
        let token_info = JSON.parse(temp_token_info)

        let access_level_aux = 0

        if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {

          let profile_access_aux = profile_access.find(el => el.name.toLowerCase() === token_info.user_info.profile.toLowerCase())
          if(profile_access_aux !== undefined && profile_access_aux !== null) {
              set_user_access_level(profile_access_aux.level)
              access_level_aux = profile_access_aux.level
          }

          set_dados(is_logged_in.current = true)

        }
        else {
          set_dados(is_logged_in.current = false)
        }

        if(is_logged_in.current) {
          if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
            set_dados_navbar(props.dados_navbar)
          }

          let notifications_aux = await reqGET(Hosts.SIMCore_API + '/web/client/notification/user/state/' + Hosts.companycode + '/' + token_info.user_info.id + '/0')
          if(notifications_aux !== undefined && notifications_aux !== null) {
            set_dados(array_notification.current = notifications_aux.data)
          }
          else {
            set_dados(array_notification.current = [])
          }

          let documents_aux = await reqGET(`${Hosts.SIMCore_API}/web/relation/user/${Hosts.companycode}/${token_info.user_info.id}/documents`)
          if(documents_aux !== undefined && documents_aux !== null) {
            set_dados(array_documents.current = documents_aux.data)
          }
          else {
            set_dados(array_documents.current = [])
          }

          let downloads_aux = await reqGET(`${Hosts.SIMCore_API}/web/relation/user/${Hosts.companycode}/${token_info.user_info.id}/downloads`)
          if(downloads_aux !== undefined && downloads_aux !== null) {
            set_dados(array_downloads.current = downloads_aux.data)
          }
          else {
            set_dados(array_downloads.current = [])
          }

          if(access_level_aux >= 5) {
            const get_user_name = async (id) => {

                let result = ''
                let aux_user = await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${id}`)
                if(aux_user.data !== undefined && aux_user.data.length > 0) {
                    result = aux_user.data[0].info.name
                }
                return result
            }

            const get_tickets = async (type) => {

              let res = await reqGET(`${Hosts.SIMCore_API}/web/support/type/open/${Hosts.companycode}/${type}`)
              if(res.data.length > 0) {
                  return res.data
              }
              else {
                return []
              }

            }
            set_dados(array_assistances.current = await get_tickets('assistance'))
            set_dados(array_complaints.current = await get_tickets('complaint'))
            set_dados(array_proposals.current = await get_tickets('proposal'))
            set_dados(array_suggestions.current = await get_tickets('suggestion'))
          }
          else {
            let news_aux = await reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/news`)
            if(news_aux !== undefined && news_aux !== null) {

              var hoje = new Date();
              let aux = []
              news_aux.data.forEach((v) => {
                if(v.info.date.published !== undefined && v.info.date.published !== '') {
                    var date_p = new Date(v.info.date.published)
      
                    if(hoje >= date_p) {
                      if(v.info.date.avaiable !== '') {
                          var date_a = new Date(v.info.date.avaiable);

                          if(hoje <= date_a) {
                              aux.push(v)
                          }
                      }
                      else {
                          aux.push(v)
                      }
                    }
                }
              })

              set_dados(array_news.current = aux)
            }
            else {
              set_dados(array_news.current = [])
            }
          }

        }

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
          set_dados_config(props.dados_config)
        }

        setLoading(false)
    })()

  }, [])
  
  const do_login = async () => {

    if(username !== '' && pwd !== '') {
        let dados_envio = {
            companycode: Hosts.companycode,
            username: username,
            password: passwordHash(pwd)
        }

        reqPOST(Hosts.SIMCore_API + '/login', dados_envio)
            .then(objToken => {
                if (objToken.token !== false && (profile_access.find(el => el.name.toLowerCase() === objToken.user_info.profile.toLowerCase()) !== undefined && profile_access.find(el => el.name.toLowerCase() === objToken.user_info.profile.toLowerCase()) !== null)) {
                    console.log('objToken.user_info', objToken.user_info)
                    
                    usarToken().saveToken(objToken, objToken.user_info)

                    window.location.reload();
                }
                else {

                    Swal.fire(language[lang].failed_login, language[lang].incorrect_login_data, 'warning')
                    localStorage.clear()

                }
            })

    }
    else {
      Swal.fire(language[lang].failed_login, language[lang].incorrect_login_data, 'warning')
    }
 
  }

  const do_logout = async () => {
      usarToken().logout()
  }

  const handleChangeUsername = (e) => {
    const { value } = e.target;

    set_username(value)

  }

  const handleChangePwd = (e) => {
    const { value } = e.target;

    set_pwd(value)
    
  }

  const new_user = () => {

    window.location.href = Hosts.EMAIL_WEB_SITE_URL + '/regist/user';

  }

  const send_recovery_request = async () => {

    const { value: email } = await Swal.fire({
      title: language[lang].recover_password,
      input: "email",
      inputLabel: language[lang].email,
      inputPlaceholder: language[lang].email_placeholder,
      confirmButtonText: language[lang].send,
      confirmButtonColor: 'var(--primary) !important',
      validationMessage: language[lang].email_error
    });

    if (email) {
      await reqGET(Hosts.SIMCore_API + '/entities/password/recovery/' + Hosts.companycode + '/' + email)
        .then(async res => {

          if(res.status === 200) {
            let link_aux = Hosts.EMAIL_WEB_SITE_URL + '/regist/user/recovery/' + res.data

            let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + ';border:1px solid transparent;border-collapse:collapse;">' +
                                  '<tr style="border-collapse: collapse;">' +
                                      '<td align="left" class style="padding:40px; border-collapse:collapse;">' +
                                          '<div>'+
                                              '<h4 style="margin-top:0; text-transform: uppercase;">'+ language[lang].contact_recovery +':</h4>'+
                                              '<span><label>' + language[lang].password_recover + '</label></span>'+
                                              '<br/>'+
                                              '<br/>'+
                                              '<span><label>' + language[lang].password_recover_2 + ' <a href="'+ link_aux +'" alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '">' + language[lang].recover_password + '</a></label></span>'+
                                              '<br/>'+
                                              '<br/>'+
                                              '<span><label>' + language[lang].password_recover_3 + '</label></span>'+
                                          '</div>'+
                                      '</td>' +
                                  '</tr>' +
                                '</table>'

            await functionSendMail(Hosts.contactFrom, [email], [], language[lang].contact_recovery, mail_content, [], dados_config)

            Swal.fire({
              title: language[lang].submitted_application,
              text: language[lang].email_recover_pass,
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: 'var(--primary) !important',
              confirmButtonText: language[lang].continuar
            })

          }
          else {
            Swal.fire({
              title: language[lang].incorrect_request,
              text: language[lang].email_recover_pass_2,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: 'var(--primary) !important',
              confirmButtonText: language[lang].continuar
            })

          }
        })
        .catch(() => 404)
    }
	}

  const dateDifferenceInHours = (dateInitial, dateFinal) => {

    let formattedDateInitial = dateInitial
    let formattedDateFinal = dateFinal

    let result = 0
    let text = language[lang].time_seconds
    result = Math.floor((formattedDateFinal - formattedDateInitial) / 1_000);
    if(result > 60) {
        result =  Math.floor((formattedDateFinal - formattedDateInitial) / 60_000);
        text = result === 1 ? language[lang].time_minute : language[lang].time_minutes

        if(result > 60) {            
            result =  Math.floor((formattedDateFinal - formattedDateInitial) / 3_600_000);
            text = result === 1 ? language[lang].time_hour : language[lang].time_hours

            if(result > 24) {
                result =  Math.floor((formattedDateFinal - formattedDateInitial) / 86_400_000);
                text = result === 1 ? language[lang].time_day : language[lang].time_days

                if(result > 15) {
                    result =  Math.floor((formattedDateFinal - formattedDateInitial) / 604_800_000);
                    text = result === 1 ? language[lang].time_week : language[lang].time_weeks

                    if(result > 60) {
                        result =  Math.floor(Math.max(
                            (dateFinal.getFullYear() - dateInitial.getFullYear()) * 12 +
                              dateFinal.getMonth() -
                              dateInitial.getMonth(),
                            0
                        ));
                        text = result === 1 ? language[lang].time_month : language[lang].time_months
                        
                        if(result > 60) {
                            result =  Math.floor((formattedDateFinal - formattedDateInitial) / 12);
                            text = result === 1 ? language[lang].time_year : language[lang].time_years
                        }
                    }
                }
            }
        }
    }

    return result + ' ' + text

  }

  window.addEventListener('popstate', function (e) {
    // console.error('eeeeeeee', e)
    var state = e.state;
    if (state !== null) {
      //load content with ajax
    }
  });
  //window.addEventListener("focus", async() => await on_init(setLoading));

  return (
    isloading ?

      <Loader />

    :

    <div className={'welcome'}>
        <h1 className='h1-heading visually-hidden-focusable'>
          {
            dados_config.content !== undefined && dados_config.content[0].title !== undefined ?
              translate(dados_config.content[0].title, lang)
            :
              Hosts.webSiteTitle
          }
        </h1>
        
        <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

        {
        is_logged_in.current ?
          <div className='container my-5'>
            <div className='row'>
              {
              user_access_level < 5 ?
                <div className='col-12 col-lg-8'>
                  <div className="row">
                      <div className="col-12">
                          <h3 className="titulo-pp text-center">
                              {language[lang].news}
                          </h3>
                      </div>
                  </div>
                  
                  {
                  array_news.current.length > 0 ?
                      <div className="row justify-content-center">
                          {
                              array_news.current.map((content) => {
                                  return (
                                      content.content.map((el, k) => {  
                                          return (
                                              <div key={k} className="col-12 col-md-6 col-lg-4 mb-5">
                                                  <div className="card">
                                                      <a href={'./article/' + (content.info['slug'] !== undefined && content.info.slug !== '' ? content.info.slug : content.id)} title={language[lang].keep_reading}>
                                                          <div className="noticia-img"> 
                                                              {
                                                              lang !== 'pt' && el['language'] !== undefined && el['language'][lang_id] !== undefined && el['language'][lang_id] !== null && el['language'][lang_id]['media'] !== null && el['language'][lang_id]['media']['image'] !== undefined && el.language[lang_id]['media']['image'].length > 0 ?
                                                                  <AssecImage 
                                                                      linkImage={el['language'][lang_id]['media']['image'][0]['link'] !== '' ? el['language'][lang_id]['media']['image'][0]['link'] : repo_img_link('nophoto.webp')}
                                                                      width="450"
                                                                      height="300"
                                                                      fit='crop'
                                                                      type='img'
                                                                      sClass="img-fluid" 
                                                                      alt={el['language'][lang_id]['media']['image'][0]['name']}
                                                                  />
                                                              :
                                                                  el['media'] !== undefined && el['media']['image'] !== undefined && el['media']['image'].length > 0 ?
                                                                      <AssecImage 
                                                                          linkImage={el['media']['image'][0]['link'] !== '' ? el['media']['image'][0]['link'] : repo_img_link('nophoto.webp')}
                                                                          width="450"
                                                                          height="300"
                                                                          fit='crop'
                                                                          type='img'
                                                                          sClass="img-fluid" 
                                                                          alt={el['media']['image'][0]['name']}
                                                                      />
                                                                  :
                                                                      <AssecImage 
                                                                          linkImage={repo_img_link('nophoto.webp')}
                                                                          width="450"
                                                                          height="300"
                                                                          fit='crop'
                                                                          type='img'
                                                                          sClass="img-fluid" 
                                                                          alt={'no_photo'}
                                                                      />
                                                              }
                                                          </div>
                                                      </a>
                                                      <div className="card-body">
                                                          <div className="timestamp">{parse(content.info.date.published.split('T')[0])}</div>
                                                          <div className="card-title">
                                                              {(lang === 'pt' || el.language === undefined ? el.title : (el.language[lang_id] === undefined || el.language[lang_id].title === undefined || el.language[lang_id].title === '' ? el.title : el.language[lang_id].title))}
                                                          </div>
                                                          <div className="card-text d-none">
                                                              {ReactHtmlParser(lang === 'pt' || el.language === undefined ? el.abstract : (el.language[lang_id] === undefined || el.language[lang_id].abstract === undefined || el.language[lang_id].abstract === '' ? el.abstract : el.language[lang_id].abstract))}
                                                          </div> 
                                                      </div>
                                                      <div className="px-3 text-end mb-3">
                                                          <a className="btn btn-text" href={'./article/' + + (content.info['slug'] !== undefined && content.info.slug !== '' ? content.info.slug : content.id)}>{language[lang].learn_more}<i className="bi bi-chevron-right"></i></a>
                                                      </div>

                                                      <div className="card-footer text-muted d-none">
                                                          <i className="bi bi-tag pe-2" />
                                                          {
                                                              content.info.tags.map((v, k) => {
                                                                  return (
                                                                      <span key={k} className="pill-tag">{v.text}</span>
                                                                      )
                                                                  })
                                                          }
                                                      </div>
                                                  </div>
                                              </div> 
                                          )
                                      })
                                  )
                              })
                          }
                      </div>
                  : 
                    null
                  }

                </div>
              :
                null
              }
              <div className={user_access_level < 5 ? 'col-12 col-lg-4 mx-auto' : 'col-12 col-lg-6 mx-auto'}>
                {
                array_notification.current !== undefined && array_notification.current !== null && array_notification.current.length > 0 ? 
                  <div className='pb-5'>
                    <h5>{language[lang].notifications}</h5>
                    <div className="list-group">
                      {
                      array_notification.current.map((el_not, k_not) => {
                        return (
                          <a key={k_not} href={Hosts.WEB_SITE_URI + 'list/notifications'} className="list-group-item list-group-item-action" aria-current="true">
                            <div className="d-flex w-100 justify-content-between">
                              <small className="mb-0">{el_not.info.title}</small>
                              <small>{dateDifferenceInHours(new Date(el_not.info.date), new Date())}</small>
                            </div>
                          </a>
                        )
                      })
                      }
                    </div>
                  </div>
                :
                  null
                }
                {
                array_assistances.current !== undefined && array_assistances.current !== null && array_assistances.current.length > 0 ?                  
                  <div className='pb-5'>
                    <h5>{language[lang].label_assistances}</h5>
                    <div className="list-group">
                      {
                      array_assistances.current.map((el_supp, k_supp) => {
                        return (
                          <a key={k_supp} href={Hosts.WEB_SITE_URI + 'support/assistance'} className="list-group-item list-group-item-action" aria-current="true">
                            <div className="d-flex w-100 justify-content-between">
                              <small className="mb-0">{el_supp.info.name}</small>
                              <small>{dateDifferenceInHours(new Date(el_supp.info.date), new Date())}</small>
                            </div>
                          </a>
                        )
                      })
                      }
                    </div>
                  </div>
                :
                  null
                }
                {
                array_complaints.current !== undefined && array_complaints.current !== null && array_complaints.current.length > 0 ?                  
                  <div className='pb-5'>
                    <h5>{language[lang].label_complaints}</h5>
                    <div className="list-group">
                      {
                      array_complaints.current.map((el_supp, k_supp) => {
                        return (
                          <a key={k_supp} href={Hosts.WEB_SITE_URI + 'support/complaint'} className="list-group-item list-group-item-action" aria-current="true">
                            <div className="d-flex w-100 justify-content-between">
                              <small className="mb-0">{el_supp.info.name}</small>
                              <small>{dateDifferenceInHours(new Date(el_supp.info.date), new Date())}</small>
                            </div>
                          </a>
                        )
                      })
                      }
                    </div>
                  </div>
                :
                  null
                }
                {
                array_proposals.current !== undefined && array_proposals.current !== null && array_proposals.current.length > 0 ?                  
                  <div className='pb-5'>
                    <h5>{language[lang].label_proposals}</h5>
                    <div className="list-group">
                      {
                      array_proposals.current.map((el_supp, k_supp) => {
                        return (
                          <a key={k_supp} href={Hosts.WEB_SITE_URI + 'support/proposal'} className="list-group-item list-group-item-action" aria-current="true">
                            <div className="d-flex w-100 justify-content-between">
                              <small className="mb-0">{el_supp.info.name}</small>
                              <small>{dateDifferenceInHours(new Date(el_supp.info.date), new Date())}</small>
                            </div>
                          </a>
                        )
                      })
                      }
                    </div>
                  </div>
                :
                  null
                }
                {
                array_suggestions.current !== undefined && array_suggestions.current !== null && array_suggestions.current.length > 0 ?                  
                  <div className='pb-5'>
                    <h5>{language[lang].label_suggestions}</h5>
                    <div className="list-group">
                      {
                      array_suggestions.current.map((el_supp, k_supp) => {
                        return (
                          <a key={k_supp} href={Hosts.WEB_SITE_URI + 'support/suggestion'} className="list-group-item list-group-item-action" aria-current="true">
                            <div className="d-flex w-100 justify-content-between">
                              <small className="mb-0">{el_supp.info.name}</small>
                              <small>{dateDifferenceInHours(new Date(el_supp.info.date), new Date())}</small>
                            </div>
                          </a>
                        )
                      })
                      }
                    </div>
                  </div>
                :
                  null
                }
              </div>
            </div>
            <div className='row'>
              <div className='col-6'>
                {
                array_documents.current !== undefined && array_documents.current !== null && array_documents.current.length > 0 ?
                  <div className='py-5'>
                    <h5>{language[lang].last_documents}</h5>
                    <div className="list-group">
                      {
                      array_documents.current.map((el_doc, k_doc) => {
                        if(k_doc < 5) {
                          return (
                            <a key={k_doc} href={Hosts.WEB_SITE_URI + 'relation/documents'} className="list-group-item list-group-item-action" aria-current="true">
                              <div className="d-flex w-100 justify-content-between align-items-center">
                                <small className="mb-0">{el_doc.info.name}</small>
                                <small className='text-nowrap'>{dateDifferenceInHours(new Date(el_doc.info.date), new Date())}</small>
                              </div>
                            </a>
                          )
                        }
                        else {
                          return null
                        }
                      })
                    }
                    </div>
                  </div>
                :
                  null
                }
              </div>
              <div className='col-6'>
                {
                array_downloads.current !== undefined && array_downloads.current !== null && array_downloads.current.length > 0 ?
                  <div className='py-5'>
                    <h5>{language[lang].last_downloads}</h5>
                    <div className="list-group">
                      {
                        array_downloads.current.map((el_down, k_down) => {
                          if(k_down < 5) {
                            return (
                              <a key={k_down} href={Hosts.WEB_SITE_URI + 'relation/downloads'} className="list-group-item list-group-item-action" aria-current="true">
                                <div className="d-flex w-100 justify-content-between align-items-center">
                                  <small className="mb-0">{el_down.info.name}</small>
                                  <small className='text-nowrap'>{dateDifferenceInHours(new Date(el_down.info.date), new Date())}</small>
                                </div>
                              </a>
                            )
                          }
                          else {
                            return null
                          }
                        })
                      }
                    </div>
                  </div>
                :
                  null
                }
              </div>
            </div>
          </div>
        :
          <div className='container my-5'>
            <div className='row'>
              <div className='col-10 col-sm-6 col-md-6 col-lg-4 text-center mx-auto my-5 py-5'>
                <div className="form-group mb-3">
                    <label> {language[lang].username} </label>
                    <input type="text" name="username" value={username} className="form-input w-100 form-control-lg rounded-0 border-0 bg-color-gray-light" onChange={(e) => handleChangeUsername(e)} />
                </div>
                <div className="form-group mb-3">
                    <label> {language[lang].password} </label>
                    <input type="password" name="pwd" value={pwd} className="form-input w-100 form-control-lg rounded-0 border-0 bg-color-gray-light" onChange={(e) => handleChangePwd(e)} />
                </div>
                
                <div className="form-group mt-5">
                    <button type="button" className="btn btn-primary" onClick={() => do_login()}>
                      {language[lang].login}
                    </button>
                </div>
                <div className='form-group mt-3'>
                  <button type="button" className="btn btn-link" onClick={() => new_user()}>{language[lang].register_here}</button>

                  <button type="button" className="btn btn-link" variant="primary" onClick={() => send_recovery_request()}>{language[lang].recover_password}</button>
                </div>
              </div>
            </div>
          </div>
        }

        <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

      </div>
  )
}

export default Pagina;